'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var _module = angular.module('cb.strips.cbStripCoveoSitecoreV1', []);

_module.directive('cbStripCoveoSitecoreV1', cbStripCoveoSitecoreV1);

exports.default = _module;


function cbStripCoveoSitecoreV1() {
    return {
        restrict: 'A',
        link: cbStripCoveoSitecoreV1Link
    };

    function cbStripCoveoSitecoreV1Link(scope, element, attr) {
        document.addEventListener('DOMContentLoaded', function () {
            var root = document.getElementById('search');
            Coveo.SearchEndpoint.endpoints['default'] = new Coveo.SearchEndpoint({
                restUri: attr.apiBaseUrl
            });
            Coveo.$$(root).on('buildingQuery', function (e, args) {
                var queryBuilder = args.queryBuilder;
                var constantExpressions = JSON.parse(attr.constantExpressions);
                _.each(constantExpressions, function (constantExpression) {
                    queryBuilder.constantExpression.add(constantExpression);
                });
                var advancedExpressions = JSON.parse(attr.advancedExpressions);
                _.each(advancedExpressions, function (advancedExpression) {
                    queryBuilder.advancedExpression.addFieldExpression(advancedExpression.name, advancedExpression.operator, JSON.parse('[' + advancedExpression.value + ']'));
                });
                queryBuilder.enableDuplicateFiltering = true;
            });
            Coveo.init(root, {
                enableDuplicateFiltering: true
            });
        });
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/strips/coveo-sitecore-v1/coveo-sitecore.directive.js
// module id = 936
// module chunks = 1